/**
 * Created by swandelow on 9/6/16.
 */
angular.module('CarsSaraBo').directive('inputMeter', function () {
    return {
        scope: {
            ngModel: '=ngModel',
            min: '=min',
            max: '=max',
            step: '=step',
            placeholder: '=placeholder',
            name: '@',
            isRequired : '=',
            errorFields: '=',
            default: '=default',
            editable: '=editable'
        },

        link: function (scope) {

            scope.increase = function () {
                if (scope.ngModel != undefined) {
                    if (scope.ngModel < scope.max) {
                        scope.ngModel += scope.step;
                    }
                } else {
                    scope.ngModel = scope.min;
                }
                updateValidation(scope.name);
            };

            scope.decrease = function () {
                if (scope.ngModel > scope.min) {
                    scope.ngModel -= scope.step;
                    updateValidation(scope.name);
                }
            };

            scope.$watch('ngModel', function () {
                updateValidation(scope.name);
            });

            scope.$watch('isRequired', function () {
                if(scope.isRequired != undefined && scope.default != undefined){
                    if(!scope.isRequired){
                        delete scope.ngModel;
                    }else{
                        scope.ngModel = scope.default;
                    }
                }
            });

            function updateValidation(field) {
                if (scope.errorFields != undefined && scope.errorFields[field]) {
                    scope.errorFields[field] = null;
                }
            }
        },

        templateUrl: 'assets/commons/input-meter.html'
    };
});


//////////////////
// WEBPACK FOOTER
// ./public/app/models/directives/input_meter_directive.js
// module id = 876
// module chunks = 3